import { render, staticRenderFns } from "./faceClass.vue?vue&type=template&id=04a09b2a&scoped=true"
import script from "./faceClass.vue?vue&type=script&lang=js"
export * from "./faceClass.vue?vue&type=script&lang=js"
import style0 from "./faceClass.vue?vue&type=style&index=0&id=04a09b2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a09b2a",
  null
  
)

export default component.exports